export const vendooImages = {
  csvExport: [
    {
      src: 'https://cdn.magicpatterns.com/uploads/ea6Y2TL17Ra2h5uCDiNNTo/V2.png',
      alt: 'Vendoo Settings, Export CSV tab: Export Inventory form with start and end date, an All Inventory checkbox, All Headers or Customize Headers options, and a Generate CSV button',
      caption: 'Pick a date range, or all inventory, and generate the file.',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/aBcZ1EurnGE8ZgG9GkExWh/V2-1.png',
      alt: 'Vendoo Customize Headers list with checked fields: Images, Title, Description, Brand, Condition, Primary Color, Secondary Color, Tags, SKU, Category, Price, Status, Listed Date, Sold Date and Shipped Date',
      caption: 'Or customize the headers, now including sold and shipped dates.',
    },
  ],
  researchNotes: {
    src: 'https://cdn.magicpatterns.com/uploads/xgJwvr2uTnjfLxyw5BBRzj/Definitions.avif',
    alt: 'Research notes: what to track (average sale price, profit, sell-through rate, categories, brands, size, how it sold), a CSV workaround for older items, reference tools, and focus group questions for sellers who do and don’t use spreadsheets',
  },
  wireframe: {
    src: 'https://cdn.magicpatterns.com/uploads/cLjFDHi2wyDbba1xKD3AwY/Prototype.jpg',
    alt: 'Grayscale wireframe of the analytics page: week/month/quarter/year filter, revenue and profit line chart, marketplace donut charts, bar charts by marketplace, and top-5 lists for categories, sub-categories and brands',
  },
  finalDashboard: {
    src: 'https://cdn.magicpatterns.com/uploads/sdGJturgtnLcDo1tKCpKCn/analytics1.png',
    alt: 'Final Vendoo analytics page: revenue and profit chart with summary, marketplace revenue and profit donuts, average sale price and sold items by marketplace, and top-5 selling categories, sub-categories and brands',
  },
  userPost: {
    src: 'https://cdn.magicpatterns.com/uploads/hsHwDFnxrSmVj6Hx2mYmQM/2b87bc40-4951-4efd-bb44-a17722460ee7.avif',
    alt: 'Instagram post by a reseller showing her Vendoo analytics on a laptop, with $664 profit for the first two months of the year, and a caption about reselling part time',
  },
  userComments: [
    {
      src: 'https://cdn.magicpatterns.com/uploads/unWTjkG6qt1BqjyVPNHM4C/02837b4f20264123b101593fa34ffe2d_jpg_Exp.avif',
      alt: 'Instagram comment: “I love it so far! Never did I think a whole analytics feature would be added. I love seeing in a snapshot which categories are selling best for me and on which platforms.”',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/76W7aH5jvFmARKhPsRLK9u/47b7d52aa0744bc8aaabb6f86e897832_jpg_Exp.avif',
      alt: 'Instagram comment: “I love it soooo much! More than ever I’ve been able to see how much I’m actually making… I was trying to find a way to get a list of sold items and profit in an excel sheet.”',
    },
  ],
};
